angular
	.module 'App.Repository'
	.factory 'ProductFilterValueRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductFilterValueRepository extends BaseRepository
				@resource = '/product_filter_values'
				@isRestricted = true

			return new ProductFilterValueRepository
	]
